import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackBoardTemplatesCreated.meta';

export type TrackBoardTemplatesCreatedParams = {
  prompt: string;
  number_of_boards: number;
};

export const useTrackBoardTemplatesCreated = () => {
  const { track } = useAnalyticsUtilities();

  const trackBoardTemplatesCreated = useCallback(
    (params: TrackBoardTemplatesCreatedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackBoardTemplatesCreated };
};
